'use client'
import { signOut, useSession } from "next-auth/react"
import { CButton } from "@coreui/react"
import CIcon from "@coreui/icons-react"
import { cilAccountLogout } from "@coreui/icons" // <-- Importamos el icono de salida

export default function LogoutButton() {
    const { data: session } = useSession()

    const handleLogout = async () => {
        const idToken = session?.idToken

        // 1. Destruye las cookies locales de la aplicación Next.js
        await signOut({ redirect: false })

        // 2. Traemos las variables públicas
        const keycloakIssuer = process.env.NEXT_PUBLIC_KEYCLOAK_ISSUER
        const clientId = process.env.NEXT_PUBLIC_KEYCLOAK_CLIENT_ID
        const postLogoutRedirectUri = window.location.origin

        // 3. Construimos la URL de Keycloak
        let logoutUrl = `${keycloakIssuer}/protocol/openid-connect/logout?client_id=${clientId}&post_logout_redirect_uri=${encodeURIComponent(postLogoutRedirectUri)}`

        if (idToken) {
            logoutUrl += `&id_token_hint=${idToken}`
        }

        // 4. Redirección oficial hacia Keycloak
        window.location.href = logoutUrl
    }

    return (
        <CButton
            variant="ghost"
            color="danger"
            onClick={handleLogout}
            className="px-2 py-1 border-0 d-flex align-items-center justify-content-center gap-2"
            title="Cerrar Sesión" // Muestra un texto flotante al pasar el mouse
        >
            <CIcon icon={cilAccountLogout} size="lg" />
            <span>Cerrar sesión</span>
        </CButton>
    )
}
